export default "__VITE_ASSET__8a1372ed__"